import { useEffect } from 'react';
import { bridge, isApp } from 'shared/src/utils';
import { useInstanceId } from 'shared/src/hooks';

export const useReportTTFD = () => {
  // const { params } = useMarketRoute<'MarketHome'>();

  const instanceId = useInstanceId();
  useEffect(() => {
    if (isApp()) {
      bridge.reportTTFD({ instanceId: instanceId });
    }
  }, [instanceId]);
};
